import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NotificationsDomainModule } from '@p2p/notifications/domain';

import { NotificationsApiService } from './services/notifications.api.service';

@NgModule({
    imports: [CommonModule, NotificationsDomainModule],
    providers: [NotificationsApiService]
})
export class NotificationsApiModule {}
